var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 433,
    height: 202,
    viewBox: "0 0 433 202",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M378.125 307.799C360.566 347.01 325.73 380.481 285.274 412.518C245.517 444.002 210.634 482.719 144.047 493.168C78.21 503.499 8.33411 473.89 -61.8048 466.98C-130.078 460.255 -212.861 482.277 -263.6 453.011C-316.927 422.253 -294.231 372.416 -297.477 331.047C-299.656 303.281 -267.733 278.683 -279.438 251.162C-298.563 206.197 -396.196 170.209 -384.619 126.166C-374.245 86.7031 -289.952 72.4279 -228.213 56.2898C-165.003 39.7667 -93.851 16.4305 -24.3384 31.99C46.8022 47.9139 52.8423 112.551 120.074 134.249C205.227 161.732 331.09 124.327 395.062 167.35C452.273 205.827 398.481 262.342 378.125 307.799Z",
    fill: "#EE6A29"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M380.098 306.135C363.675 340.95 330.874 370.572 292.751 398.89C255.285 426.72 222.466 461.011 159.51 469.987C97.2643 478.861 31.0015 452.166 -35.3994 445.675C-100.034 439.356 -178.258 458.554 -226.411 432.258C-277.021 404.621 -255.788 360.373 -259.061 323.536C-261.258 298.812 -231.172 277.073 -242.382 252.52C-260.697 212.405 -353.255 179.897 -342.515 140.752C-332.891 105.678 -253.2 93.3825 -194.861 79.3192C-135.13 64.9205 -67.9176 44.4963 -2.0672 58.6841C65.3255 73.2042 71.3557 130.765 135.077 150.406C215.786 175.283 334.698 142.602 395.44 181.208C449.762 215.734 399.138 265.775 380.098 306.135Z",
    fill: "#008894"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.da558c215ee401e652f84a2f2c76ea4b.svg";
export { ForwardRef as ReactComponent };